import React, { forwardRef, useEffect, useState } from "react";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { Avatar } from "@material-ui/core";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { FaFilePdf } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { SummaryCard } from "../../components/StyledComponent";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import { urlImg } from "../../components/data";
import CheckBox from "../../../../../../../templates/ApplicationDetails/components/EmpReusableComp/CheckBox";

const MapSubmissionSummarys = forwardRef(({ formData, ref, handleDeclarationChange, declarationChecked, showDeclaration = false, logoData }) => {
  const [, applicationFlow] = useDepartmentSelector();

  const { t } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const feeDetail = formData?.taxHeadEstimates?.[0];
  const paymentHead = formData?.taxHeadEstimates?.[0]?.paymentHeadDefinition;
  const documents = formData?.documents;
  const [loading, setLoading] = useState(false);
  //const [iframesrc, setIframeSrc] = useState("");
  const schemeType = formData?.descriptionOfLand?.schemeType === "Scheme";
  const mergedId = formData?.mergeSelfMapDocsId;
  let nameOfDepartment;
  const isDA = formData?.department === "DA";
  const currentLogoId = isDA ? logoData?.boundary?.find((item) => item.name === formData?.locationDistrict)?.fileStoreId : logoData?.fileStoreId;
  const fetchLogoUrl = async () => {
    if (!currentLogoId) return;
    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    setLogoUrl(result);
  };
  // if (isEmployee) {
  nameOfDepartment = isDA ? `${formData?.district?.toUpperCase()} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  useEffect(() => {
    fetchLogoUrl();
  }, [logoData, formData]);
  // useEffect(async () => {
  //   const url = await getDocumentByFileStoreId(mergedId, setLoading, true);
  //   setIframeSrc(url);
  //   console.log("handleCHangeisTriggered", typeof url, url);
  // }, []);
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
      }}
      ref={ref}
    >
      <div style={{ display: "flex", padding: "5px", background: "rgb(230, 239, 248)" }}>
        <div style={{ background: "white", borderRadius: "50%" }}>
          <img
            src={logoUrl}
            alt="Uttar-Pradesh-Logo"
            style={{
              marginTop: isDA ? "0.5em" : "1em",
              height: "4em",
              width: "auto",
              objectFit: "contain",
            }}
          />
        </div>
        <div style={{ color: "#1f4a7c" }}>
          <p style={{ marginLeft: "12px", fontSize: "1.25rem", fontWeight: "600", fontFamily: '"Calibri", sans-serif' }}>{nameOfDepartment}</p>
          <p style={{ marginLeft: "12px", fontFamily: '"Calibri", sans-serif', fontWeight: "500" }}>Government of Uttar Pradesh</p>
        </div>
      </div>

      <div className="groupContainer" style={{ width: "100%", marginTop: "1rem" }}>
        {/* General Information */}
        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Application Form</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  {/*   Name of Owner  */}
                  {formData?.selectedOffice && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Name of Authority:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.selectedOffice}</td>
                    </tr>
                  )}
                  {formData?.applicationNo && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Application No:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.applicationNo}</td>
                    </tr>
                  )}
                  {formData?.descriptionOfLand?.schemeType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Scheme Type :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.schemeType}</td>
                    </tr>
                  )}
                  {formData?.plotinMelaArea && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Is your plot in the mela area declared under the Uttar Pradesh Melas Act, 1938?:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>
                        {formData.plotinMelaArea.charAt(0).toUpperCase() + formData.plotinMelaArea.slice(1)}
                      </td>
                    </tr>
                  )}
                  {formData?.plotSubdivided && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Is your plot has been subdivided?:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>
                        {formData.plotSubdivided.charAt(0).toUpperCase() + formData.plotSubdivided.slice(1)}
                      </td>
                    </tr>
                  )}
                  {formData?.plotinColonies && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Is your plot in unauthorized layouts/ colonies ?:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>
                        {formData.plotinColonies.charAt(0).toUpperCase() + formData.plotinColonies.slice(1)}
                      </td>
                    </tr>
                  )}
                  {formData?.landInfo?.owners?.[0]?.name && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Name of Owner:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.landInfo?.owners?.[0]?.name}</td>
                    </tr>
                  )}

                  {/* son/wife/Daughter */}
                  {formData?.landInfo?.owners?.[0]?.fatherOrHusbandName && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Son/Wife/Daughter of:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.landInfo?.owners?.[0]?.fatherOrHusbandName}</td>
                    </tr>
                  )}

                  {/* Address for Correspondence */}
                  {formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Address for Correspondence :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address}</td>
                    </tr>
                  )}

                  {/* Enter Mobile No */}
                  {formData?.landInfo?.owners?.[0]?.mobileNumber && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Mobile No :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.landInfo?.owners?.[0]?.mobileNumber}</td>
                    </tr>
                  )}

                  {/* Aadhaar Number */}
                  {formData?.landInfo?.owners?.[0]?.aadhaarNumber && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Aadhaar Number :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.landInfo?.owners?.[0]?.aadhaarNumber}</td>
                    </tr>
                  )}

                  {/* Type of Permission */}
                  {formData?.permissionType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Type of Permission :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.permissionType}</td>
                    </tr>
                  )}

                  {/*Land Use  */}
                  {formData?.zoneType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>{schemeType ? "Land Use as per Layout Plan:" : "Land Use as per Master Plan"}</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.zoneType}</td>
                    </tr>
                  )}
                  {/* Land Sub Use */}
                  {formData?.subZoneType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>{schemeType ? "Land Sub Use as per Layout Plan:" : "Land Sub Use as per Master Plan"}</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.subZoneType}</td>
                    </tr>
                  )}
                  {/* Primary Use of Proposed Activity */}
                  {formData?.primaryUse && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Primary Use of Proposed Activity:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.primaryUse}</td>
                    </tr>
                  )}
                  {/* Proposed Activity */}
                  {formData?.activityProposed && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Proposed Activity :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.activityProposed}</td>
                    </tr>
                  )}
                  {formData?.developmentArea && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Development Area :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.developmentArea}</td>
                    </tr>
                  )}
                  {formData?.containFAR && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Does proposal contain Purchasable FAR? :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData.containFAR.charAt(0).toUpperCase() + formData.containFAR.slice(1)}</td>
                    </tr>
                  )}
                  {/* Plot Area */}
                  {formData?.plotArea && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Plot Area (Sqmt):</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.plotArea}</td>
                    </tr>
                  )}
                  {formData?.plotNo && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>{schemeType ? <b>Plot No.</b> : <b>Plot No./Khasra No.</b>}</td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.plotNo}</td>
                    </tr>
                  )}
                  {formData?.totalBuildUpArea && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Built-up Area</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.totalBuildUpArea}</td>
                    </tr>
                  )}
                  {formData?.totalProposedArea && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Net Plot Area</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.totalProposedArea}</td>
                    </tr>
                  )}
                  {/* district*/}
                  {formData?.district && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>District :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.district}</td>
                    </tr>
                  )}
                  {/*Proposed Site  */}
                  {formData?.proposalType && schemeType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Proposed Site:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.proposalType}</td>
                    </tr>
                  )}
                  {/* Tehsil*/}
                  {formData?.tehsil && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Tehsil :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.tehsil}</td>
                    </tr>
                  )}
                  {/* Village */}
                  {formData?.revenueVillage && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Village :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.revenueVillage}</td>
                    </tr>
                  )}
                  {/* Scheme Name */}
                  {formData?.schemeName && schemeType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Scheme Name :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.schemeName}</td>
                    </tr>
                  )}
                  {/* Mohalla Name */}
                  {formData?.revenueVillageMohal && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Mohalla Name :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.revenueVillageMohal}</td>
                    </tr>
                  )}
                  {/* Layout No. */}
                  {formData?.layoutsanctionNumber && schemeType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Layout Approval Sanction No.:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.layoutsanctionNumber}</td>
                    </tr>
                  )}
                  {/* Layout Sanction Date */}
                  {formData?.layoutsanctionDate && schemeType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Layout Approval Sanction Date:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.layoutsanctionDate}</td>
                    </tr>
                  )}
                  {formData?.descriptionOfLand?.landAddress && !schemeType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Land Address :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.landAddress}</td>
                    </tr>
                  )}
                  {formData?.descriptionOfLand?.landAddress && !schemeType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Nearby Landmark :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.landMark}</td>
                    </tr>
                  )}
                  {formData?.descriptionOfLand?.landLength && !schemeType && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Access road width (RoW) :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.landLength}</td>
                    </tr>
                  )}
                  {formData?.plotInfo?.estimatedCost && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Estimated Cost (₹):</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.plotInfo?.estimatedCost}</td>
                    </tr>
                  )}
                  {/* declaration */}
                  {formData?.declaration && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>
                          <CheckBox
                            name="declaration"
                            defaultValue={formData?.declaration}
                            // control={control}
                            // onChange={handleDeclarationChange}
                            disabled={true}
                            // rules={{ required: "You must agree to the terms and conditions" }}
                          />
                        </b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{t("DECLARATION_SELF_CERTIFICATION_APPLICATION_FORM")}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard>

        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Documents Section</h2>{" "}
          </div>
          <div className="formInputContainer">
            <Grid container spacing={2}>
              {documents?.map((document, index) => {
                const documentType =
                  document?.additionalDetails?.title || document?.documentType?.charAt(0).toUpperCase() + document?.documentType?.slice(1);
                return (
                  <Grid item xs={12} md={6} key={index}>
                    {" "}
                    {/* Two items per row on medium screens and above */}
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={9}>
                        <strong>{documentType}</strong>:
                      </Grid>{" "}
                      {/* Label part */}
                      <Grid item xs={3}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => getDocumentByFileStoreId(document?.fileStoreId, setIsPreviewLoading)}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </SummaryCard>

        {formData?.approvalCertificateUrl && formData?.selfDrawingPdfUrl && (
          <SummaryCard className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">Letters</h2>{" "}
            </div>
            <div className="formInputContainer">
              <Grid container spacing={2} alignItems="center">
                {/* Approval Letter */}
                <Grid item xs={3}>
                  <strong>Approval Letter</strong>:
                </Grid>
                <Grid item xs={3}>
                  <FaFilePdf
                    color="#a10505"
                    style={{ width: "20px", height: "30px", cursor: "pointer" }}
                    onClick={() => window.open(formData?.approvalCertificateUrl, "_blank", "noopener,noreferrer")}
                  />
                </Grid>

                {/* Approval Map */}
                <Grid item xs={3}>
                  <strong>Approval Map</strong>:
                </Grid>
                <Grid item xs={3}>
                  <FaFilePdf
                    color="#a10505"
                    style={{ width: "20px", height: "30px", cursor: "pointer" }}
                    onClick={() => window.open(formData?.selfDrawingPdfUrl, "_blank", "noopener,noreferrer")}
                  />
                </Grid>
              </Grid>
            </div>
          </SummaryCard>
        )}
        {/* <iframe className="fastPas-iframe" src={iframesrc} width="100%" height="800px" title="PDF Viewer" /> */}
        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Details of Map</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  {/*   Location of plot along with existing roads and their width  */}
                  {formData?.planlocationOfPlot && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Does the attached Plan show: Location of plot along with existing roads and their width?</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>
                        {formData.planlocationOfPlot.charAt(0).toUpperCase() + formData.planlocationOfPlot.slice(1)}
                      </td>
                    </tr>
                  )}
                  {/*  Dimensions of plot/premise along with setback  */}
                  {formData?.plandimensionOfPlot && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Does the attached Plan show: Dimensions of plot/premise along with setback?</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>
                        {formData.plandimensionOfPlot.charAt(0).toUpperCase() + formData.plandimensionOfPlot.slice(1)}
                      </td>
                    </tr>
                  )}
                  {/*  Include floor plans of all floors together with the covered area clearly indicating sizes of rooms and the position and width of staircases and other exits  */}
                  {formData?.planfloorPlans && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>
                          Does the attached Plan: Include floor plans of all floors together with the covered area clearly indicating sizes of rooms
                          and the position and width of staircases and other exits?
                        </b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>
                        {formData.planfloorPlans.charAt(0).toUpperCase() + formData.planfloorPlans.slice(1)}
                      </td>
                    </tr>
                  )}
                  {formData?.containMoreThanThree && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Is your proposal contain more than 3 floors?</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>
                        {formData.containMoreThanThree.charAt(0).toUpperCase() + formData.containMoreThanThree.slice(1)}
                      </td>
                    </tr>
                  )}
                  {/*  Height of Building */}
                  {formData?.planheightOfBuilding && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Height of Building :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.planheightOfBuilding}</td>
                    </tr>
                  )}
                  {/*  Details of parking spaces provided (If plot size is more than 50 sqm) */}
                  {formData?.plansParkingSpace && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Details of parking spaces provided (If plot size is more than 50 sqm) :</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{formData?.plansParkingSpace}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard>

        {/* Fee Information */}
        {/* <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Fee Details</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  {paymentHead?.map((payment, index) => (
                    <tr key={index}>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>{payment?.feeType}:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{payment?.amount}</td>
                    </tr>
                  ))}
                  {feeDetail?.estimateAmount && (
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Total Fee:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px", fontWeight: "bolder" }}> ₹ {feeDetail?.estimateAmount} only</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard> */}

        {/* Additinal Fee Information */}

        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Fee Details</h2>
          </div>

          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  {paymentHead?.map((item, index) => (
                    <tr key={index}>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>{item.feeType}:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>₹ {item.amount}</td>
                    </tr>
                  ))}

                  {/* Total Fee */}
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Total Fee:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px", fontWeight: "bolder" }}>
                      ₹ {paymentHead?.reduce((acc, curr) => acc + Number(curr.amount || 0), 0)} only
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard>

        {showDeclaration && (
          <div className="formContainer">
            <FormControlLabel
              style={{ padding: "10px 15px" }}
              control={<Checkbox name="declaration" checked={declarationChecked} onChange={handleDeclarationChange} />}
              label={
                <span style={{ fontStyle: "italic" }}>
                  I, {Digit.UserService.getUser()?.info?.name || "User"} ,{t("DECLARATION_SELF_CERTIFICATION_APPLICATION_FORM")}{" "}
                </span>
              }
            />
          </div>
        )}
      </div>
    </div>
  );
});
export default MapSubmissionSummarys;
